import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import { getCategoryHomeMode } from '../../graphqlDic';
// import * as Links from '../../links/linksHome';
import { connect } from 'react-redux';
import MoviesMedia from '../../components/HomeComponents/MoviesMedia';
import SliderList from './../../containers/SliderList';
import Partners from '../../containers/Partners';
// import Slider from "react-slick";

class ContentMedia extends Component {

    ShowContentMedia = (getCategoryHomeMode) => {
        let result = null;
        if (getCategoryHomeMode.length) {
            result = getCategoryHomeMode.map((category, index) => (
                <MoviesMedia
                    key={ index }
                    dataCategory={ category }
                />
            ));
        }
        return result;
    }

    render() {
        this.props.getCategoryHomeMode.refetch();
        const { getCategoryHomeMode: { loading, error, getCategoryHomeMode } } = this.props;
        if (loading) return <div className="container"><p className="text-center">Loading...</p></div>;
        if (error) return error.message;
        return (
            <div className="block-index">
                <div className="block-index">
                    <SliderList type={ null } home_slider_mode={true} />
                </div>
                {
                    getCategoryHomeMode && getCategoryHomeMode.length ?
                    this.ShowContentMedia(getCategoryHomeMode) :
                    <div className="container"><p className="text-center">Không có nội dung!!!</p></div>
                }
                <Partners />
            </div>
        );
    }

}

export default compose(
    graphql(getCategoryHomeMode, {
        name: 'getCategoryHomeMode',
    }),
)(connect(
    null,
    null
)(ContentMedia));



// WEBPACK FOOTER //
// ./src/containers/HomePega/ContentMedia.js